import { Injectable } from "@angular/core";
import { Moment } from "moment";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CalendarLayoutService {
  private jumpToDateSubject = new Subject<"L" | "R" | Moment>();

  jumpToDate$ = this.jumpToDateSubject.asObservable();

  constructor() {}

  jumpToDate(date: "L" | "R" | Moment) {
    this.jumpToDateSubject.next(date);
  }
}
